import Intercom, {
  boot as bootIntercom,
  shutdown as shutdownIntercom,
  update as updateIntercom,
} from '@intercom/messenger-js-sdk'
import { INTERCOM_Z_INDEX, isIntercomDisabled } from 'src/utils/env'

export type IntercomUserData = {
  user_id: string
  name: string
  email?: string
  company: {
    company_id?: string
    name?: string
  }
}

class IntercomService {
  private isScriptLoaded = false

  public isEnabled() {
    return Boolean(process.env.REACT_APP_INTERCOM_APP_ID) && !isIntercomDisabled()
  }

  private getIdentifiedSettings(userData: IntercomUserData) {
    return {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID as string,
      alignment: 'left',
      z_index: INTERCOM_Z_INDEX,
      hide_default_launcher: false,
      ...userData,
    }
  }

  public identifyUser(userData: IntercomUserData) {
    if (!this.isEnabled()) {
      return
    }

    const settings = this.getIdentifiedSettings(userData)

    if (!this.isScriptLoaded) {
      Intercom({
        region: 'us',
        ...settings,
      })

      this.isScriptLoaded = true

      return
    }

    bootIntercom(settings)
  }

  public updateIdentifiedUser(userData: IntercomUserData) {
    if (!this.isEnabled()) {
      return
    }

    updateIntercom(this.getIdentifiedSettings(userData))
  }

  public syncIdentifiedUser(userData: IntercomUserData) {
    if (!this.isEnabled()) {
      return
    }

    if (!this.isScriptLoaded) {
      this.identifyUser(userData)

      return
    }

    this.updateIdentifiedUser(userData)
  }

  public shutdownOnLogout() {
    if (!this.isScriptLoaded) {
      return
    }

    shutdownIntercom()
    this.isScriptLoaded = false
  }
}

export const intercomService = new IntercomService()
